import type { CmsAttributeConfiguration } from '../cms';
import type { GenericDecorator } from './decorator.type';

/**
 * Declares CMS manifest details that cannot be safely inferred from @Attribute.
 * Use `exclude: true` to omit an inherited or otherwise non-CMS attribute.
 * The decorator is intentionally metadata-only; build tooling reads its AST.
 */
export function CmsAttribute(
    _config: CmsAttributeConfiguration
): GenericDecorator<void, ClassFieldDecoratorContext> {
    return (): void => undefined;
}
